import { render } from "./WithdrawalsPage.vue?vue&type=template&id=2758f0c4"
import script from "./WithdrawalsPage.vue?vue&type=script&lang=js"
export * from "./WithdrawalsPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__